import React, { useState, useEffect } from 'react';
import { Modal, Box, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { fetchLinkingOrders, fetchOrderById, fetchOrders, linkedOrder, unlinkOrder } from '../../../redux/orderSlice'; // Import actions from the slice
import MainTable from '../../../components/Table/PaginationTable'; // Your custom MainTable component
import { useSelector, useDispatch } from 'react-redux';
// import { LinkedOrderColumnDef } from '../../columns/columnDef';
import { ParentCompanyColumns } from '../columns/columns';
import { useTranslation } from 'react-i18next';
import { fetchParentCompanyDetails, getCompanyDetailsById, linkedParentCompany } from '../../../redux/adminSlice';
import { useNavigate } from 'react-router-dom';


const LinkedParentCompanyModal = ({ open, onClose, linkedCompanyList, actionType, companyId, linkedId, totalRecordsLink }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [myState, setMyState] = useState(location.state?.activeCompanyDetails)
    const isLoading = useSelector(state => state.order.loading);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
    const [pageSize, setPageSize] = useState(10);
    const linkedCompanyListDetails = useSelector(state => state.admin.parentCompanyList || []);
    // const findParentCompany = linkedCompanyListDetails.find(co => co.companyId === companyId)
    // const linkedCompanyId = findParentCompany? findParentCompany : 0;
    // const [linkedCompanyNo, setLinkCompanyNo] = useState(linkedCompanyListDetails.parentCompanyId);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

    const totalRecords = useSelector(state => state.admin.parentCompanyPaginationInfo.totalRecords || {});
    const getCompanyIdByName = (companyArray, companyId) => {
        const company = companyArray.find(company => company.companyId === companyId);
        return company ? company.companyId : null;
      }
      const linkedCompanyId = getCompanyIdByName(linkedCompanyListDetails, companyId);
    const handleUnlinkCompany = (linkedCompanyData, actionType) => {
        // console.log('Handle Link Order', linkCompanyData, "Order Details :", linkedCompanyListDetails, "From Landing :", companyId)
        console.log('handleUnlink Working', linkedCompanyData)

        // console.log('Check newOrderID for Link:', orderDetails.orderId)
        const linkedOdata = {
            action: actionType,
            parentCompanyId: 0
        }
        dispatch(linkedParentCompany({
            linkedCompanyId:linkedId,
            linkedCompanyData: linkedOdata

        })).then(() => {
            console.log('Link Successful')
            dispatch(getCompanyDetailsById(linkedId));
            // dispatch(fetchOrders({
            //     type: 'outgoing',
            //     searchText: '',
            //     fromDate: '',
            //     toDate: '',
            //     pageSize, // Use state value
            //     pageNumber
            //   }))
        })
        onClose()
        navigate(-1)
    }

    const handleLinkCompany = (linkedCompanyData, actionType) => {
        console.log('Handle Link Order', linkedCompanyData)

        // console.log('Check newOrderID for Link:', orderDetails.orderId)
        const linkedCdata = {
            action: actionType,
            parentCompanyId: linkedCompanyData.companyId,
        }
        dispatch(linkedParentCompany({
            linkedCompanyId: linkedId ,
            linkedCompanyData: linkedCdata

        })).then(() => {
            console.log('Link Successful')
            setMyState(linkedCompanyData.parentCompanyName)
            // navigated(location.pathnam, {
            //     state
            //     : { ...location.state,
            //     myState
            //     : linkedCompanyData.parentCompanyName },
            //     replace
            //     : true })
            dispatch(getCompanyDetailsById(linkedId));
            // dispatch(fetchOrders({
            //     type: 'outgoing',
            //     searchText: '',
            //     fromDate: '',
            //     toDate: '',
            //     pageSize, // Use state value
            //     pageNumber
            //   }))
        })
        onClose()
        navigate(-1)
    }

    const parentCompanyViewFn = (companyId, actionType) => {
        // navigate(`/review-active-orders/${companyId}`); // Navigate to create order page
      }
    // const linkedCompanyList = LinkedOrderColumnDef(handleLinkCompany, handleUnlinkCompany, linkedOrderNum, t)
    const parentCompanyColumns = ParentCompanyColumns(handleLinkCompany,handleUnlinkCompany,linkedCompanyId, t)
    // Function to handle search input changes
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        const queryParams = {
            searchText: searchTerm,
            companyKeyId: linkedId,
            pageSize, // Use state value
            pageNumber, // Use state value
        };
        dispatch(fetchParentCompanyDetails(queryParams));

    };
    // Handle page size change
    const handlePageIndexChange = (newPageIndex) => {
        setPageNumber(newPageIndex);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        console.log("Page size changed to:", newSize);
    };


    useEffect(() => {
        console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
        const queryParams = {
            searchText: '',
            companyKeyId: linkedId,
            pageSize, // Use state value
            pageNumber, // Use state value
        };
        if(location.state?.actionType === 'edit')
        dispatch(fetchParentCompanyDetails(queryParams));
    }, [dispatch, pageSize, pageNumber]);


    //     return orderNumber || orderDate
    //     // || populationMatch || sizeMatch; // Combine all checks with OR
    // }) : [];

    // console.log('Count ', filteredOrders, linkedCompanyList[0])
    // if (isLoading) {
    //     return <div>Loading...</div>; // Or any other loading indicator
    // }
    // Adjust Box styling to your preference
    // console.log('`>>> Linked <<<<<`', linkedCompanyList, actionType, orderId,orderDetails);
    console.log('Total Records is------------------------------------------>', linkedCompanyListDetails,linkedCompanyId,linkedId,location.state)
    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', maxHeight: '90vh', bgcolor: 'background.paper', boxShadow: 24, p: 4, overflowY: 'auto' }}>
                <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
                <TextField
                    fullWidth
                    label="Search Company"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    sx={{ mb: 2 }}
                />
                <MainTable
                    columns={parentCompanyColumns}
                    data={linkedCompanyList}
                    // enablePagination={false}
                    initialPageSize={pageSize}
                    pageNumber={pageNumber}
                    onPageIndexChange={handlePageIndexChange}
                    onPageSizeChange={handlePageSizeChange}
                    enablePagination={true}
                    totalRecords={totalRecords} // Pass the totalRecords to MainTable
                    // className="custom-table-class"
                    recordCountText="records found"
                />
            </Box>
        </Modal>
    );
}

export default LinkedParentCompanyModal;
